import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { CfgIntegracaoModulo } from '../../model/cfg-integracao-modulo.model';
import { ProvedorDeAssinaturaDTO } from 'src/app/seguranca/configuracao/assinatura-digital/model/provedor-de-assinatura-dto.model';
import { CfgIntegracaoModuloFilter } from './model/cfg-integracao-modulo.filter';
import { Status } from 'src/app/core/framework/default.model';
import { TipoIntegracao } from './model/tipo-integracao.enum';
import { catchError, map } from 'rxjs/operators';
import { ListaResultset } from 'src/app/core/list/lista-resultset.interface';
import { CfgIntegracaoGrupoFuncao } from '../../model/cfg-integracao-grupo-funcao.model';
import { CfgIntegracaoEvento } from '../../model/cfg-integracao-evento.model';
import { CfgIntegracaoEventoCliente } from '../../model/cfg-integracao-evento-cliente.model';


@Injectable({
  providedIn: 'root'
})
export class CfgIntegracaoModuloService extends DefaultService<CfgIntegracaoModulo> {

  constructor(
    public httpClient: HttpClient,
    public errorHandler: ErrorHandlerService
  ) {
      super(
        httpClient,
        errorHandler,
        '/api/cfgintegracao/cfgintegracaomodulo/v1/cfgintegracaomodulo'
      );
  }

  private grupoFuncaoPossuiEventoCliente(cfgIntegracaoGrupoFuncao: CfgIntegracaoGrupoFuncao): boolean {
    let possuiEventoCliente = false;

    cfgIntegracaoGrupoFuncao
      .cfgIntegracaoEventos
      .forEach((cfgIntegracaoEvento: CfgIntegracaoEvento) => {
        cfgIntegracaoEvento
          .cfgIntegracaoEventosCliente
          .forEach((cfgIntegracaoEventoCliente: CfgIntegracaoEventoCliente) => {
            if ( cfgIntegracaoEventoCliente.status === Status.ATIVO ) {
              possuiEventoCliente = true;
            }
          });
      });

    return possuiEventoCliente;
  }

  buscarProvedoresDeAssinaturaDigitalAtivos(): Observable<ProvedorDeAssinaturaDTO[]> {
    const filter: CfgIntegracaoModuloFilter = {
      status: Status.ATIVO,
      tipoIntegracao: TipoIntegracao.ASSINATURA_DIGITAL
    };

    const provedores: ProvedorDeAssinaturaDTO[] = [];

    return this.listar(filter)
        .pipe(
          map((result:  ListaResultset<CfgIntegracaoModulo>) => {
            if ( result.content.length > 0 ) {
              result.content
                    .forEach((modulo: CfgIntegracaoModulo) => {
                      modulo.cfgIntegracaoGruposFuncao
                            .forEach((cfgIntegracaoGrupoFuncao: CfgIntegracaoGrupoFuncao) => {
                              let possuiEventoCliente = this.grupoFuncaoPossuiEventoCliente(cfgIntegracaoGrupoFuncao);

                              provedores.push({
                                chaveCfgIntegracaoGrupoFuncao: cfgIntegracaoGrupoFuncao.chave,
                                idCfgIntegracaoGrupoFuncao: cfgIntegracaoGrupoFuncao.id,
                                nome: cfgIntegracaoGrupoFuncao.nome,
                                ativoNesteTenant: possuiEventoCliente
                              });
                            })
                    })
            }

            return provedores;
          })
          , catchError(err => throwError(this.errorHandlerService.handle(err)))
        );
  }
}
